export const ALL_RESOURCES_FOLDER = "all";

export const STORAGE_UPGRADE_LINK = "https://share.hsforms.com/1ym9_HCz8QOS15vlRLKW1YQ3is1h";
